// extracted by mini-css-extract-plugin
export default {"iconContainer":"language-icon_iconContainer__y+7tn","icon":"language-icon_icon__byXY5"};